<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    backgroundClass: {
      type: String,
      default: 'bg-white',
    },
    addShadow: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    overflowClass: {
      type: String,
      default: 'overflow-hidden',
    },
  },
  computed: {
    classes(): string {
      return `${this.backgroundClass} ${this.overflowClass} ${this.shadowClasses} ${this.roundedClassName}`
    },
    roundedClassName(): string {
      return this.small ? 'rounded-md' : 'rounded-lg'
    },
    shadowClasses(): string {
      return this.addShadow ? 'shadow-xs' : ''
    },
  },
})
</script>
